import AppDispatcher from './../flux/AppDispatcher';
import PreferencesConstants from './../constants/PreferencesConstants';
var dispatcher = AppDispatcher.get(PreferencesConstants.DISPATCHER);

var PreferencesActions = {
    registerCreatePreferencesComponent(getPrefencesComponentFunc: any, applicationName: string) {
        dispatcher.dispatch({
            actionType: PreferencesConstants.SET_ACTIVE_PREFERENCES,
            getPrefencesComponentFunc: getPrefencesComponentFunc,
            applicationName: applicationName 
        });
    },
    registerCreateUserSystemPreferencesComponent(getPrefencesComponentFunc: any) {
        dispatcher.dispatch({
            actionType: PreferencesConstants.SET_USER_SYSTEM_PREFERENCES,
            getPrefencesComponentFunc: getPrefencesComponentFunc,

        });
    },
   
}

export default PreferencesActions;